import { render, staticRenderFns } from "./MenuSummaryIcon.vue?vue&type=template&id=4bdbeb1a&"
import script from "./MenuSummaryIcon.vue?vue&type=script&lang=ts&"
export * from "./MenuSummaryIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports